/**
 * テキストリンク
 */

type Props = {
  text: string;
  typeFile?: boolean;
  accept?: string; // typeFile True専用
  onClick?: () => void;
  onChange?: () => void; // typeFile True専用
};

const TextLink = ({
  text,
  typeFile = false,
  accept = 'image/jpeg, image/jpg, image/png, image/gif',
  onClick,
  onChange,
}: Props) => {
  // 通常のボタン
  if (!typeFile) {
    return (
      <button
        className='text-xs text-primary-500 underline hover:no-underline'
        type='button'
        onClick={onClick}
      >
        {text}
      </button>
    );
  }
  // ファイル選択ボタン
  return (
    <label className='cursor-pointer text-xs text-primary-500 underline hover:no-underline'>
      <input
        className='sr-only appearance-none'
        type='file'
        accept={accept}
        onChange={onChange}
      />
      <span>{text}</span>
    </label>
  );
};

export default TextLink;
